import {ProductImage} from '../../interfaces/product.interface';
import {ApiService} from '../api';
import {URLS, UrlUtils} from '../urls';

export interface CheckoutResult {
  image_url: string;
  price: CheckoutPriceData;
  url: string;
  name?: string;
  shipping?: CheckoutPriceData;
  is_fallback?: boolean;
  picture?: ProductImage;
}

interface CheckoutPriceData {
  value: string;
  currency: string;
}

interface CheckoutProductsList {
  products: CheckoutResult[];
  total: number;
}

interface CheckoutData {
  rakuten: CheckoutProductsList;
  ebay: CheckoutProductsList;
}

export class CheckoutService extends ApiService {
  getCheckoutInfo(code: string | number): Promise<CheckoutData> {
    const url = UrlUtils.insertValueToUrl(URLS.CHECKOUT_PRODUCT_INFO, code);

    return this.get(url).then(resp => resp.json());
  }
}
